let env = ''
if (process.env.CUSTOM_ENV === 'test') {
  env = 'test.'
} else if (process.env.CUSTOM_ENV === 'dev') {
  env = 'dev.'
} else if (process.env.CUSTOM_ENV === 'beta') {
  env = 'beta.'
}

let template = 'ap'
if (process.env.CUSTOM_ENV === 'test') {
  template = 'test.tp'
} else if (process.env.CUSTOM_ENV === 'dev') {
  template = 'dev.tp'
} else if (process.env.CUSTOM_ENV === 'beta') {
  template = 'beta.ap'
}

// const aiTemplate = 'web'
// if (process.env.CUSTOM_ENV === 'test') {
//   template = 'testwebhok'
// } else if (process.env.CUSTOM_ENV === 'dev') {
//   template = 'devwebhok'
// } else if (process.env.CUSTOM_ENV === 'beta') {
//   template = 'betawebhok'
// }
export default {
  title: '伏羲云',
  favivon: '/hokfavicon.png',
  appName: '云获课管理APP',
  aiAgent: false,
  ossUrl: 'https://oss.aifxy.com', // 项目oss 图片
  VUE_APP_HUOSHAN_PSSTERURI: `https://${env}cover.aifxy.com/`, // 火山封面图
  VUE_APP_BASE_AI_URL: `wss://${window.location.hostname}/newApi`,
  VUE_APP_ACTIVATION_URL: 'https://ap.aifxy.com/share?orderNo=',
  VUE_APP_QUESTIONNAIRE_URL: `https://${template}.aifxy.com/questionnaire?id=`,
  VUE_APP_H5_URL: `https://${env}h5.aifxy.com/`,
  VUE_APP_TEMPLATE_URL: `https://${template}.aifxy.com`,
  VUE_APP_BASE_URL: 'https://web.aifxy.com/',
  CLOUD_URL: `https://${env}cloud.aifxy.com`,
  WELCOME_URL: 'https://ac.fuxisys.com/iuHVx',
  publicKey:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCpAPiHBGnFj2+9lPQ76fEhuQDUel8Jev2o0+Oc4hhIOEWzAyFACvpLWZyfrQi0x+0Q0ADmA391djK2kzNMgu1Ukx3jb+GT9Wqu/bl+QzgE02j1D8GOH9hjZ33QlGZmloKRxJE7LS6Psr9Jt5Zu0wS9ERU1qdfT58TJmdxcoZlzGQIDAQAB',
  downloadMocMedia: 'https://oss.aifxy.com/yijianfabu/fuxiyun2.0.dmg?t=',
  downloadAndriodMedia: 'https://oss.aifxy.com/yijianfabu/fuxiyun2.0.exe?t=',
  downloadMacLive: 'https://oss.aifxy.com/common/fxyLive-macOS.dmg?t=',
  downloadAndriodLive:
    'https://oss.aifxy.com/common/fxyLive_release_setup(x64).exe?t=',
  QUESION_URL: `https://wq.fxyvv.com`,
}
